<!--
 * @Author: zyy
 * @Date: 2022-12-01 13:32:00
 * @LastEditors: zyy
 * @LastEditTime: 2022-12-01 13:39:48
 * @Description: default
-->

<template>
    <div class="payment-record app-region blank-l-h blank-r-h">
      <a-row :gutter="64" type="flex">
        <a-col :span="24" :xl="6" class="divide">
          <div class="page-title">社区列表</div>
          <a-input placeholder="请输入关键词" v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
          <a-spin tip="加载中..." :spinning="tree.loading">
            <a-tree class="list" block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys"></a-tree>
          </a-spin>
        </a-col>
        <a-col :span="24" :xl="18">
          <div class="page-title">{{name}}（{{total}}）</div>
          <OutInList :community-id="tree.selectedKeys[0]" @total="setTotal"></OutInList>
        </a-col>
      </a-row>
    </div>
  </template>
  
  <script>
    import CommunityService from '@/io/community.js';
    import OutInList from './OutInList.vue';
  
    export default {
      name: 'PaymentRecord',
      data() {
        return {
          tree: {
            selectedKeys: [],
            keyword: null,
            loading: false,
            data: [],
            searchData: [],
            params: {
              children: 'children',
              title: 'name',
              key: 'id'
            }
          },
          name: null,
          total: 0
        }
      },
      components: {
        OutInList,
      },
      activated() {
        if (this.tree.data.length) {
          this.initSideData();
        }
      },
      mounted() {
        this.initSideData();
      },
      methods: {
        initSideData() {
          this.initTreeData().then(() => {
            let key = this.tree.data[0][this.tree.params.key];
            this.$depthSearchTree(node => {
              if (node[this.tree.params.key] === this.tree.selectedKeys[0]) {
                key = this.tree.selectedKeys[0];
              }
            }, this.tree.data);
            this.selectTreeNode([key]);
          });
        },
        selectTreeNode(selectedKeys) {
          if (selectedKeys.length) {
            this.tree.selectedKeys = selectedKeys;
            this.setName();
          }
        },
        setName() {
          this.name = this.tree.data.filter(val => val[this.tree.params.key] === this.tree.selectedKeys[0])[0][this.tree.params.title];
        },
        initTreeData() {
          this.tree.loading = true;
          return CommunityService.listPage().then(res => {
            this.tree.data = res;
          }).catch(err => {}).finally(() => {
            this.tree.loading = false;
          });
        },
        setTotal(total) {
          this.total = total;
        }
      }
    }
  </script>
  
  <style lang="less" scoped>
  
  </style>